import {Collection} from "../../types/types";
import Header from "./Header";
import ImageList from "./ImageList";

interface GalleryProps {
    collection: Collection | null,
    locale: string,
    setLocale: (locale: string) => void,
}

const Gallery = ({collection, locale, setLocale}: GalleryProps) => {

    if (collection === null) {
        return null;
    }

    return <>
        <Header collection={collection} locale={locale} setLocale={setLocale}/>
        <ImageList collection={collection} locale={locale}/>
    </>
}

export default Gallery;